import { z } from 'zod'
import { oc } from '@orpc/contract'

export const authorizationGenerate = oc
  .route({ method: 'POST', path: '/v2/authorization/generate' })
  .input(
    z.object({
      // Only honored for provider-portal (Practitioner) callers. Patient-portal
      // callers are locked to their own id server-side (see the handler),
      // mirroring consentGenerate.
      patientId: z.string(),
      organizationId: z.string(),
    }),
  )
  .output(
    z.object({
      isSigned: z.boolean(),
      // FHIR Bundle (DocumentReference + Consent) the signing UI renders.
      bundle: z.any().optional(),
    }),
  )
